import { render } from "./SearchWithAi.vue?vue&type=template&id=c9fd0476&scoped=true"
import script from "./SearchWithAi.vue?vue&type=script&lang=js"
export * from "./SearchWithAi.vue?vue&type=script&lang=js"

import "./SearchWithAi.vue?vue&type=style&index=0&id=c9fd0476&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9fd0476"]])

export default __exports__